// extracted by mini-css-extract-plugin
module.exports = {"time":"Info_time__1CUw4","pulsate":"Info_pulsate__1JvaW"};